import React, { memo } from 'react';
import {
    Box,
    Button,
    Typography,
    Checkbox
} from '@mui/material';
import {
    Settings as SettingsIcon,
    Update as UpdateIcon
} from '@mui/icons-material';
import CommonTableControls, { 
    CommonIconButton, 
    CommonSelectionDisplay 
} from '../../../../components/common/CommonTableControls';
import AllMyToggle from '../../../../components/common/AllMyToggle';
import {
    ColumnSelectionPanel,
    ColumnSelectionGrid,
    ColumnSelectionItem
} from '../styles';

const TableControls = memo(({
    t,
    showMyOrderOnly,
    setShowMyOrderOnly,
    toggleColumnPanel,
    columnPanelOpen,
    columnsToUse,
    checkedColumns,
    handleCheckColumn,
    selectAllColumns,
    unselectAllColumns,
    selectedItems,
    onStatusUpdate
}) => {
    const leftContent = (
        <Box sx={{ 
            display: 'flex', 
            justifyContent: 'flex-start', 
            gap: 1.5, 
            alignItems: 'center',
            flexWrap: 'wrap'
        }}>
            <CommonSelectionDisplay
                selectedItems={selectedItems}
                customLabel={t('common.itemsSelected', { count: selectedItems.length })}
                customNoItemsLabel={t('common.noItemsSelected')}
            />
            
            <CommonIconButton
                onClick={onStatusUpdate}
                disabled={selectedItems.length === 0}
                tooltip={t('invoice.updateStatus') || '상태 업데이트'}
                variant="success"
            >
                <UpdateIcon />
            </CommonIconButton>
        </Box>
    );

    const rightContent = (
        <Box sx={{ 
            display: 'flex', 
            justifyContent: 'flex-end', 
            alignItems: 'center',
            gap: 1.5,
            width: '100%'
        }}>
            <AllMyToggle
                checked={showMyOrderOnly}
                onChange={setShowMyOrderOnly}
                t={t}
            />
            <CommonIconButton
                id="settings-button"
                onClick={toggleColumnPanel}
                tooltip={t('common.columnSelection') || '컬럼 설정'}
                variant="secondary"
                customStyles={{
                    backgroundColor: columnPanelOpen ? '#3b82f6' : '#ffffff',
                    color: columnPanelOpen ? '#ffffff' : '#6b7280',
                    border: '1px solid #e5e7eb',
                    '&:hover': {
                        backgroundColor: columnPanelOpen ? '#2563eb' : '#f9fafb',
                    }
                }}
            >
                <SettingsIcon />
            </CommonIconButton>
        </Box>
    );

    return (
        <CommonTableControls
            showIconButtons={true}
            leftContent={leftContent}
            rightContent={rightContent}
            spacing={2}
        >
            <ColumnSelectionPanel
                id="column-selection-panel"
                className={columnPanelOpen ? 'open' : ''}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="subtitle1" fontWeight="bold">
                        {t('invoice.print.columnSettings') || '인쇄 컬럼 설정'}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button
                            size="small"
                            variant="outlined"
                            onClick={selectAllColumns}
                        >
                            {t('common.selectAll') || '전체 선택'}
                        </Button>
                        <Button
                            size="small"
                            variant="outlined"
                            onClick={unselectAllColumns}
                        >
                            {t('common.unselectAll') || '전체 해제'}
                        </Button>
                    </Box>
                </Box>

                <ColumnSelectionGrid>
                    {columnsToUse.map((column) => (
                        <ColumnSelectionItem key={column.id}>
                            <Checkbox
                                checked={checkedColumns[column.id] || false}
                                onChange={() => handleCheckColumn(column.id)}
                                size="small"
                            />
                            <Typography variant="body2">
                                {column.label}
                            </Typography>
                        </ColumnSelectionItem>
                    ))}
                </ColumnSelectionGrid>
            </ColumnSelectionPanel>
        </CommonTableControls>
    );
});

TableControls.displayName = 'TableControls';

export default TableControls; 